var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 23,
    viewBox: "0 0 90 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 5.5C51.9826 6.40393 77.3893 3.79295 77.3893 3.79295L69.0022 7.47958C72.97 7.14964 76.9611 7.20505 80.9179 7.64501C88.8977 8.48395 90 10.4927 90 10.4927C90 10.4927 85.1654 9.9905 81.511 9.9905C79.2701 9.99927 77.0415 10.3195 74.8912 10.9417C77.5371 10.9228 80.1795 11.1363 82.787 11.5798C87.4539 12.336 89.323 14.0907 89.323 14.0907C86.904 13.759 84.4618 13.6206 82.0202 13.6771C80.1302 13.7763 78.2544 14.0553 76.4188 14.5101C78.4263 14.8825 80.4105 15.3677 82.3617 15.9635C84.2572 16.6525 85.99 17.716 87.4539 19.0889C87.4539 19.0889 85.2493 18.5335 82.4456 18.1141C80.6994 17.8647 78.9259 17.8647 77.1797 18.1141C77.1797 18.1141 80.4926 19.0062 82.3617 20.43C83.4068 21.212 84.3901 22.0711 85.3032 23C85.3032 23 78.1142 20.879 72.8483 19.4552C67.5824 18.0313 52.9648 18.3681 36.508 16.2412C19.4402 14.0375 0 6.36295 0 6.36295L2.71384 0C2.71384 0 19.8299 4.31839 38 5.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightHand);
export default __webpack_public_path__ + "static/media/rightHand.d583e2a91260a5d6d289c2fd1f91185f.svg";
export { ForwardRef as ReactComponent };